<template>
	<div class="card">
        <div class="card-body">
            <div v-bind:class="loading">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border m-5" role="status">
                    <span class="sr-only">{{ $t("page.general.cargar") }}</span>
                  </div>
                </div>
            </div>
            <div v-bind:class="result">
                <div class="row">
                    <div class="col-12" v-if="!setTitle">
                        <h5>{{ $t("page.constancia.mis_costancias") }}</h5>
                    </div>
                    <div class="col-12">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th scope="col">{{ $t("page.constancia.nombre_curso") }}</th>
                              <th scope="col">{{ $t("page.constancia.documento") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                                <td colspan="2" class="text-center" v-if="requerimiento.temas.length==0">
                                    <h6 class="mr-4">{{ $t("page.constancia.sin_constancia") }}</h6>
                                </td>
                            </tr>
                            <tr v-for="tema,index of requerimiento.temas" :key="index+'tema'">
                              <th scope="row">{{tema.nombre2}}</th>
                              <td>
                                    <button v-if="tema.cve_sap_modalidad!=2" v-on:click="Descargar_DC3(tema)" class="btn btn-sm btn-success">
                                        <i class="fas fa-cloud-download-alt"></i> DC3
                                    </button>
                                    <button v-on:click="Descargar_Constancia(tema)" class="btn btn-sm btn_blue">
                                        <i class="fas fa-cloud-download-alt"></i>{{ $t("page.constancia.constancia") }}
                                    </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props:['setTitle'],
    data () {
        return {
            loading:'',
            result:'d-none',
            requerimiento:{
                nombre2:'',
                temas:[]
            },
        }
    },
    methods:{
        Descargar_Constancia(requerimiento){
          this.requerimiento=requerimiento;
          var mapForm = document.createElement("form");
          mapForm.target = "_blank";
          mapForm.method = "POST";
          mapForm.id = "POST_constancia";
          mapForm.action = this.$http.options.url+'/../../../static/files/constancia/index.php';
          var mapInput = document.createElement("input");
          mapInput.type = "text";
          mapInput.name = "cve_curso";
          mapInput.id = "cve_curso";
          mapInput.value = requerimiento.cve_curso;
          var mapInput2 = document.createElement("input");
          mapInput2.type = "text";
          mapInput2.name = "cve_empleado";
          mapInput2.id = "cve_empleado";
          mapInput2.value = requerimiento.cve_empleado;
          var mapInput3 = document.createElement("input");
          mapInput3.type = "text";
          mapInput3.name = "token";
          mapInput3.id = "token";
          mapInput3.value = JSON.parse(localStorage.apiKey_lms);
          var mapInput4 = document.createElement("button");
          mapInput4.type = "submit";
          mapInput4.name = "save";
          mapInput4.id = "save";
          mapInput4.value = "Consultar";
          mapForm.appendChild(mapInput);
          mapForm.appendChild(mapInput2);
          mapForm.appendChild(mapInput3);
          mapForm.appendChild(mapInput4);
          document.body.appendChild(mapForm);
          $(document).ready(function(){
            mapForm.submit();
            setTimeout(function(){
              document.body.removeChild(mapForm);
            },1000);
          });
        },
        Descargar_DC3(requerimiento){
          console.log('DC3 curso: '+requerimiento.cve_curso);
          var mapForm = document.createElement("form");
          mapForm.target = "_blank";
          mapForm.method = "POST";
          mapForm.id = "POST_dc3";
          mapForm.action =this.$http.options.url+'/../../../static/files/dc3/index.php';
          var mapInput = document.createElement("input");
          mapInput.type = "text";
          mapInput.name = "cve_curso";
          mapInput.id = "cve_curso";
          mapInput.value = requerimiento.cve_curso;
          var mapInput2 = document.createElement("input");
          mapInput2.type = "text";
          mapInput2.name = "cve_empleado";
          mapInput2.id = "cve_empleado";
          mapInput2.value = requerimiento.cve_empleado;
          var mapInput3 = document.createElement("textarea");
          //mapInput3.type = "text";
          mapInput3.name = "token";
          mapInput3.id = "token";
          mapInput3.value = JSON.parse(localStorage.apiKey_lms);
          var mapInput4 = document.createElement("button");
          mapInput4.type = "submit";
          mapInput4.name = "save";
          mapInput4.id = "save";
          mapInput4.value = "Consultar";
          mapForm.appendChild(mapInput);
          mapForm.appendChild(mapInput2);
          mapForm.appendChild(mapInput3);
          mapForm.appendChild(mapInput4);
          document.body.appendChild(mapForm);
          $(document).ready(function(){
            mapForm.submit();
            setTimeout(function(){
              document.body.removeChild(mapForm);
            },1000);
          });
        },
        Consultar(){
            this.Cargando();
            this.$http.post('plan_capacitacion/consultar_plan_capacitacion/calificada/'+this.menu.usuario.cve_empleado,{
                buscar:''
            })
            .then(respuesta=>{return respuesta.json()})
            .then(respuestaJson=>{
                this.Listo();
                if (respuestaJson.length>0) {
                    this.requerimiento.nombre2=respuestaJson[0].nombre2;
                    for (var i = 0; i < respuestaJson[0].temas.length; i++) {
                        if (i<5) {
                            this.requerimiento.temas.push(respuestaJson[0].temas[i]);
                        }
                    }
                }else{
                    this.requerimiento={
                        nombre2:'',
                        temas:[]
                    };
                }
            })
            .catch(error=>{
              this.loading='d-none';
            });
        },
        Cargando(){
            this.result="d-none";
            this.loading="";
        },
        Listo(){
            this.result="";
            this.loading="d-none";
        }
    },
    mounted(){
        this.Consultar();
    },
    computed:{
        menu(){
          return this.$store.getters.getMenu;
        },
        usuario(){
          return this.$store.getters.getUsuario;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/MisConstancias/MisConstancias.vue